/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React from "react";

import { renderErrorMsg } from "../../../assets/component/renderErrorMsg.js";
import RenderPaymentCode from "./RenderPaymentCode";
import ToggleSwitch from "../../../assets/component/ToggleSwitch/ToggleSwitch.js";
import { mapPaymentMethodDataStatus, mapPaymentMethodData } from "../../../assets/helper.js";
import UpgradeNoticeCard from "./UpgradeNoticeCard";

const paymentMethods = [
  {
    key: "wechatpay_hk",
    label: "WeChat Pay HK (Hong Kong)",
  },
  {
    key: "wechatpay_ch",
    label: "WeChat Pay (China)",
  }
];

export function RenderWeChatPay(state, func, textObj) {
  if (!state || !func) return;

  const wechatpayHKStatus = mapPaymentMethodDataStatus(state.organizationObj.paymentMethodCode, paymentMethods[0].key);
  const wechatpayHKData = mapPaymentMethodData(state.organizationObj.paymentMethodCode, paymentMethods[0].key);
  const wechatpayHKHasQRCode = Boolean(wechatpayHKData.code);

  const wechatpayCHStatus = mapPaymentMethodDataStatus(state.organizationObj.paymentMethodCode, paymentMethods[1].key);
  const wechatpayCHData = mapPaymentMethodData(state.organizationObj.paymentMethodCode, paymentMethods[1].key);
  const wechatpayCHHasQRCode = Boolean(wechatpayCHData.code);

  if (state.loading) {
    return (
      <div className="RenderWeChatPay-loading">
        <div className="RenderWeChatPay-spinner"></div>
      </div>
    );
  }

  const currentPlan = state.organizationObj.currentPlan
    ? state.organizationObj.currentPlan.toLowerCase()
    : "";
  const isPremiumPlan = currentPlan === "premium";

  return (
    <div className="RenderWeChatPay-contentContainer">
      <div className="RenderWeChatPay-content flex column">
        {isPremiumPlan ? (
          <>
            <div className="RenderWeChatPay-wechatpayChinaLogoContainer">
              <div className="RenderWeChatPay-wechatpayChinaLogo" />
            </div>

            <div className="RenderWeChatPay-wechatpayContainer">
              {/* Payment Code */}
              <div className="RenderWeChatPay-wechatpayCodeContainer left">
                <div className="RenderWeChatPay-wechatpayText">Hong Kong</div>
                <RenderPaymentCode state={state} func={func} paymentMethod={paymentMethods[0]} />

                <div className="RenderWeChatPay-toggleContainer">
                  <ToggleSwitch
                    checked={wechatpayHKStatus.checked}
                    onChange={(e) => func.handleUpdatePaymentStatus(e, paymentMethods[0].key)}
                    disabled={!wechatpayHKHasQRCode}
                    disabledMessage={!wechatpayHKHasQRCode ? "Please upload a QR code first" : ""}
                  />
                </div>
              </div>

              <div className="RenderWeChatPay-wechatpayCodeContainer">
                <div className="RenderWeChatPay-wechatpayText">China</div>
                <RenderPaymentCode state={state} func={func} paymentMethod={paymentMethods[1]} />

                <div className="RenderWeChatPay-toggleContainer">
                  <ToggleSwitch
                    checked={wechatpayCHStatus.checked}
                    onChange={(e) => func.handleUpdatePaymentStatus(e, paymentMethods[1].key)}
                    disabled={!wechatpayCHHasQRCode}
                    disabledMessage={!wechatpayCHHasQRCode ? "Please upload a QR code first" : ""}
                  />
                </div>
              </div>
              {/* END Payment Code */}
            </div>

            {renderErrorMsg(state.errMsgInfo.submitErr.msg)}

            <div className="RenderWeChatPay-footer" />
          </>
        ) : (
          <UpgradeNoticeCard onUpgradeClick={func.redirectToOrgBilling} />
        )}
      </div>
    </div>
  );
}
